import React, { useEffect, useState } from "react";
import "./FeaturedEvent.css";
import beszELJLogo from "./assets/beszELJ_logo2.png";
import calendarIcon from "./assets/svg/date.svg";
import locationIcon from "./assets/svg/location.svg";
import placeholderImage from "./assets/image.png";
import arrowIcon from "./assets/svg/arrow.svg";
import { Link } from "react-router-dom";

const FeaturedEvent = () => {
  const [event, setEvent] = useState(null);

  useEffect(() => {
    fetch("https://beszeljegyesulet.hu/wp/wp-json/wp/v2/events?_embed&per_page=1")
      .then((res) => res.json())
      .then((data) => {
        if (data.length > 0) setEvent(data[0]);
      })
      .catch((err) => console.error("Hiba az esemény betöltésénél:", err));
  }, []);

  if (!event) {
    return (
      <section className="featured-event loading">
        <p>Betöltés...</p>
      </section>
    );
  }

  const featuredImage = event.featured_image_url || placeholderImage;
  const rawDate = event.acf?.event_date || event.meta?.event_date || null;

  let formattedDate = "Dátum nem elérhető";
  if (rawDate) {
    const match = rawDate.match(
      /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/
    );
    if (match) {
      const [_, year, month, day, hour, minute] = match;

      // Suppress time if midnight (00:00) or no time provided
      const isMidnight = (!hour && !minute) || (parseInt(hour) === 0 && parseInt(minute) === 0);
      const showTime = !isMidnight;

      const dateObj = new Date(year, month - 1, day, hour || 0, minute || 0);

      formattedDate = dateObj.toLocaleDateString("hu-HU", {
        year: "numeric",
        month: "long",
        day: "numeric",
        ...(showTime && { hour: "2-digit", minute: "2-digit" }),
      });

      formattedDate = formattedDate.charAt(0).toLowerCase() + formattedDate.slice(1);
    }
  }

  const location = event.acf?.event_location || event.meta?.event_location || "Online";
  const excerpt = event.excerpt?.rendered?.replace(/<[^>]+>/g, "")?.substring(0, 180) + "...";
  const eventLink = `/events/${event.slug}`;

  return (
    <section className="featured-event">
      <div className="featured-event-inner">
        <div className="featured-left">
          <div className="featured-logo">
            <img src={beszELJLogo} alt="beszELJ logo" />
          </div>
          <div className="featured-meta">
            <div className="meta-item">
              <img src={calendarIcon} alt="Dátum ikon" />
              <span>{formattedDate}</span>
            </div>
            <div className="meta-item">
              <img src={locationIcon} alt="Helyszín ikon" />
              <span>{location}</span>
            </div>
          </div>
          <h2
            className="featured-title"
            dangerouslySetInnerHTML={{ __html: event.title.rendered }}
          />
          <p className="featured-description">{excerpt}</p>
          <div className="featured-buttons">
            <Link to={eventLink} className="link-more">
              Tudj meg többet{" "}
              <img src={arrowIcon} alt="nyíl ikon" className="arrow-icon" />
            </Link>
          </div>
        </div>
        <div className="featured-right">
          <div className="image-container">
            <div
              className="image-container-blur"
              style={{ backgroundImage: `url(${featuredImage})` }}
              aria-hidden="true"
            />
            <img
              src={featuredImage}
              alt={event.title.rendered}
              className="featured-main-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedEvent;